export default function TextareaField({
  field,
  value = "",
  onChange,
  error,
  disabled,
}) {
  return (
    <div className="dynamic-field-control">
      <label className="dynamic-field-control__label" htmlFor={field.key}>
        {field.label}
        {field.required && (
          <span className="dynamic-field-control__required">*</span>
        )}
      </label>

      <textarea
        id={field.key}
        value={value || ""}
        placeholder={field.placeholder || ""}
        disabled={disabled}
        className={`dynamic-field-control__textarea ${
          error ? "dynamic-field-control__textarea--error" : ""
        }`}
        onChange={(e) => onChange(field.key, e.target.value)}
      />

      {field.help_text && (
        <p className="dynamic-field-control__help">{field.help_text}</p>
      )}
      {error && <span className="dynamic-field-control__error">{error}</span>}
    </div>
  );
}
